import {
  FETCH_PRODUCT_LIST,
  RESET_PRODUCT_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 10,
  },
};

const productListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_LIST:
      return { list: action.payload, others: action.others };
    case RESET_PRODUCT_LIST:
      return initialState;
    default:
      return state;
  }
};

export default productListReducer;
